import { render } from "./HomeDetail.vue?vue&type=template&id=6dae2c4c&scoped=true"
import script from "./HomeDetail.vue?vue&type=script&lang=js"
export * from "./HomeDetail.vue?vue&type=script&lang=js"

import "./HomeDetail.vue?vue&type=style&index=0&id=6dae2c4c&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dae2c4c"]])

export default __exports__